module.exports = __webpack_public_path__ + "static/media/Paper_pad.a361f51d.png";